import { Link } from "react-router-dom";
import Typography from "../components/v2/Typography";
import Button from "../components/v2/Button";
import { ArrowRight, ArrowRightCircle } from "lucide-react";
import ServicesHeader from "../atoms/ServicesHeader";
import ContactSection from "../atoms/Contact";
import BlogSection from "../atoms/BlogPreview";
import Footer from "../atoms/Footer";
import Faq from "../atoms/Faq";
import useApp from "../hooks/useApp";
import Input from "../components/v2/Input";
import Textarea from "../components/v2/TextArea";
import ContactForm from "../atoms/ContactForm";

export const faqData = [
    { q: "What is WHOIS domain lookup?", a: "Short, simple answer…" },
    { q: "What does the WHOIS database contain?", a: "Another answer…" },
  ];


const ServiceShowcaseR = () => {
    return (
        <section className="service-showcase right-aligned">
            <div className="inner">
                <div className="service-image">
                    <img src="https://f.start.me/us.gov" alt="" />
                </div>
                <div className="service-content">
                    <div className="service-text">
                        <div className="service-heading">
                            <Typography variant="h1">Domain Brokering</Typography>
                        </div>
                        <div className="service-para">
                            <Typography variant="para">Whether you are a new comer looking for a second form of revenue or a Fortune 500 Corporation looking to acquire that perfect domain NameConnect can help you.</Typography>
                            <Typography variant="para">We operate on multiple levels: discreet acquisitions, consultations on investments, portfolio management as well as intermediaries between parties to form alliances and lease plans.</Typography>
                        </div>
                    </div>
                    <div className="service-controls">
                        <Button isLink={true} linkProps={{to:"/contact"}} variant='primary'>
                            <Typography variant={'button'}>Want to buy or sell domain?</Typography>
                        </Button>
                        <Button isLink={true} linkProps={{to:"/domains-for-sale"}} variant='secondary'><Typography variant={'button'}>Browse featured domains</Typography></Button>
                    </div>
                </div>
            </div>
        </section>
    );
};


const ServiceIndividual = () => {
    return (
        <>
            <ServicesHeader active={"/services/domain-brokering"} />
            <ServiceShowcaseR />

            <section className="service-intro-showcase">
                <div className="inner">
                    <div className="service-content">
                        <div className="service-text">
                            <div className="service-heading">
                                <Typography variant="h1">What sets us apart?</Typography>
                            </div>
                            <div className="service-para">
                                <p>
                                Companies and investors regularly use NameConnect brokers to approach domain owners with an educated offer as industry leaders, we act discreetly in the hopes of attaining you the best price for your new investment while assessing the true value of the asset you’re targeting.
                                </p>
                                <ul className="with-points">
                                    <li>We handle everything related to the sales process so you can focus on what you do best.</li>
                                    <li>We handle everything related to the sales process so you can focus on what you do best.</li>
                                    <li>We handle everything related to the sales process so you can focus on what you do best.</li>
                                    <li>We handle everything related to the sales process so you can focus on what you do best.</li>
                                </ul>
                            </div>
                        </div>

                        <div className="service-text">
                            <div className="service-heading">
                                <Typography variant="h1">Our Process</Typography>
                            </div>
                            <div className="service-para">
                                <Faq data={faqData} useNumber={true} noBorder={true} leftAligned={true} />
                            </div>
                        </div>

                    </div>
                    <div className="service-form">
                        <ContactForm />
                    </div>
                </div>
            </section>

            <Faq data={faqData} noBorder={false} leftAligned={false} showHeader={true} />


            <ContactSection />
            <BlogSection />
        </>
    );
};

export default ServiceIndividual;